// test589
(589 && 0);
